import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballPlayerService, manageFootballTeamService } from "../../../../../../commons";
import { PaginatedEnsueCollection } from "../../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { ManageFootballPlayer } from "../../../../../../commons/models/football/admin/manage-football-player";

export interface ITeamPlayersAvailableOptions {
  teamId: number;
  urlOption?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
    status?: string;
  };
}
export interface IManageTeamPlayersAvailableState {
  teamPlayersAvailable: PaginatedEnsueCollection<ManageFootballPlayer>;
  teamPlayersAvailableStatus: StatusEnum;
}

const initialState: IManageTeamPlayersAvailableState = {
  teamPlayersAvailable: new PaginatedEnsueCollection<ManageFootballPlayer>(),
  teamPlayersAvailableStatus: StatusEnum.Idle,
};

export const fetchManageTeamPlayersAvailable = createAsyncThunk(
  "manage/teamPlayersAvailable",
  async (options: ITeamPlayersAvailableOptions, thunkAPI) => {
    try {
      const playersNotInTeam = await manageFootballTeamService.getPlayersAvailableForTeam(
        options.teamId,
        options.urlOption
      );
      return playersNotInTeam as PaginatedEnsueCollection<ManageFootballPlayer>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageTeamPlayersAvailableSlice = createSlice({
  name: "footballManageTeamPlayersAvailable",
  initialState: initialState,
  reducers: {
    cleanUpTeamPlayersAvailable(state) {
      state.teamPlayersAvailable = new PaginatedEnsueCollection<ManageFootballPlayer>();
      state.teamPlayersAvailableStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageTeamPlayersAvailable.pending, (state) => {
        state.teamPlayersAvailableStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageTeamPlayersAvailable.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<ManageFootballPlayer>>) => {
          state.teamPlayersAvailableStatus = StatusEnum.Succeeded;
          state.teamPlayersAvailable = action.payload;
        }
      )
      .addCase(fetchManageTeamPlayersAvailable.rejected, (state) => {
        state.teamPlayersAvailableStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamPlayersAvailable } = footballManageTeamPlayersAvailableSlice.actions;
export default footballManageTeamPlayersAvailableSlice.reducer;
